import { GroupPersonRatingContainer } from "../containers/GroupPersonRatingContainer";
export const GroupRatingPage = () => (
        <GroupPersonRatingContainer type='ME_TO_PERSON'/>
)
